// AuthReducer.js
export const loginStart = () => ({ type: "LOGIN_START" });
export const loginSuccess = (user) => ({
  type: "LOGIN_SUCCESS",
  payload: user,
});
export const loginFailure = (error) => ({
  type: "LOGIN_FAILURE",
  payload: error,
});
export const logout = () => ({ type: "LOGOUT" });

const AuthReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN_START":
      return { user: null, isFetching: true, error: null };
    case "LOGIN_SUCCESS":
      return { user: action.payload, isFetching: false, error: null };
    case "LOGIN_FAILURE":
      return { user: null, isFetching: false, error: action.payload };
    case "LOGOUT":
      return { user: null, isFetching: false, error: null };
    default:
      return state;
  }
};

export default AuthReducer;
